import React from "react";

import { getUnreadCount } from "./SocketController";
import NoMessages from "./NoMessages";
import MessageItem from "./MessageItem";

export default function MessageList(props){
	let { messages, readMessage, apiBase } =  props.socketInstance
		, total = messages.reduce(getUnreadCount, 0)
		;

	if(!total){
		return (
			<section className="message-list">
				<NoMessages />
			</section>
		);
	}

	function markAsRead(id){
		readMessage(id);
	}

	return (
		<section className="message-list">
			{messages.filter(v => !v.isRead)
				.map((mess) => {
					let messProps = {
						markAsRead,
						...mess,
					};

					if(mess.info && mess.info.component){
						messProps.component = mess.info.component;
					}

					return <MessageItem key={mess.id} {...messProps} apiBase={apiBase} />;
				})}
		</section>
	);
}

MessageList.displayName = "MessageList";
